<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  import type { AlertVariants } from '.';
  import { alertVariants } from '.';

  const props = defineProps<{
    class?: HTMLAttributes['class'];
    variant?: AlertVariants['variant'];
    size?: AlertVariants['size'];
    icon?: string;
  }>();
</script>

<template>
  <div
    data-slot="alert"
    :class="cn(alertVariants({ variant, size }), 'flex items-center gap-x-3', props.class)"
    role="alert"
  >
    <i v-if="icon" :class="icon" />
    <slot />
  </div>
</template>
